import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { GlobalService } from './../../core/';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { PropertySearchService } from '../property-search/property-search.service';
import { FavoritePropertiesService } from '../favorite-properties.service';
import { PropertyService } from './../property.service';

@Component({
  selector: 'app-favorite-properties'
  , templateUrl: './favorite-properties.component.html'
  , styleUrls: ['./favorite-properties.component.scss']
  , encapsulation: ViewEncapsulation.None
  , providers: []
})

export class FavoritePropertiesComponent implements OnInit {

  showSideBar = false;
  favoriteLoans: any[];
  searchParams = {};
  loading = false;
  favoriteLoanClass: string;
  favoriteLoansUpdateData: any[];
  reloadFavoriteBar = false;
  MyFavoritePropertiesCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesCount);
  UserFavoritePropertiesMaxCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesMaxCount);
  displayErrorMessageDialog = false;

  constructor(private _global: GlobalService
    , private _searchSvc: PropertySearchService
    , private favoritePropertiesService: FavoritePropertiesService
    , private _propertyService: PropertyService
    , private render: Renderer2) {

      favoritePropertiesService.getFavoritesCount().subscribe(count => {
        this.MyFavoritePropertiesCount = count;
      });

      favoritePropertiesService.getReloadFavoritePropertiesBar().subscribe(reload => {
        this.reloadFavoriteBar = reload;
      });

      favoritePropertiesService.getDisplayMaxFavCountErrorMessageDialog().subscribe(display => {
        this.displayErrorMessageDialog = display;
      });

    }

  ngOnInit() {
    this.searchParams = {'FavoritesOnly': 1};
    this.loading = true;
    this.favoriteLoanClass = 'far fa-heart';
    this._searchSvc
      .search((<any>_GlobalNS).api.property.search, this.searchParams)
      .subscribe(res => {
        this.favoriteLoans = (<any>res).data;
        this.favoritePropertiesService.setFavoritesCount(this.favoriteLoans.length);
        this.loading = false;
        this.favoritePropertiesService.setReloadFavoritePropertiesBar(false);
      });
  }

  displaySideBar(): void {
    this.displayErrorMessageDialog = false;
    this.showSideBar = true;
    if (this.reloadFavoriteBar) {
      this.favoriteLoans = [];
      this.ngOnInit();
    }
  }

  statusLabel(status: string, substatus: string): string {
    return ((substatus !== null) ? 'Status/Alt Status' : 'Status');
  }

  statusDisplayValue(status: string, subStatus: string): string {
    const hasMore = this.canShowMoreStatus(status, subStatus);
    const statusLabel = (subStatus !== null) ? `${status.trim()} / ${subStatus.trim()}` : status.trim();
    return (hasMore ? statusLabel.substring(0, 20) : statusLabel);
  }

  canShowMoreStatus(status: string, subStatus: string): boolean {
    const statusLength = (subStatus !== null ? subStatus.trim().length : 0) + status.trim().length;
    return statusLength > 25 ? true : false;
  }

  getDispStrategyClass(dispValue: string): string {
    if (dispValue === 'PRE-FCL') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-prefcl';
    }
    if (dispValue === 'REO') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-reo';
    }
    if (dispValue === 'FCBK') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-fcbk';
    }
    if (dispValue === 'AUC-FCL') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-fcauc';
    }
    if (dispValue === 'SS') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-ss';
    }
    if (dispValue === 'AUC') {
      return 'p-col-3 fav-strategy-corner fav-strategy-corner-other';
    }
    return 'p-col-3 fav-strategy-corner fav-strategy-corner-auc';
  }

  getFavIconClass(IsFavorite: number): any {
    if (IsFavorite === 1) {
      return 'fas fa-heart fav-heart-loan-selected';
    } else {
      return 'far fa-heart';
    }
  }

  getPropertyViewUri(PropertyId: number): string {
    return this._propertyService.getPropertyViewUri(PropertyId);
  }

  updateFavorite(el: any, propertyId: number): void {
    let proceedToUpdate = false;
    const favIconId = el.getAttribute('data-fav-loan-icon-id');
    const isFavFlag = el.getAttribute('data-fav-loan-flag');
    if (isFavFlag === '1') {
      // -- Remove from favs
      this.render.removeAttribute(el, 'class');
      this.render.addClass(el, 'far');
      this.render.addClass(el, 'fa-heart');
      el.setAttribute('data-fav-loan-flag', '0');
      proceedToUpdate = true;
    } else {
      // -- Add to favs
      if (this.MyFavoritePropertiesCount < this.UserFavoritePropertiesMaxCount) {
        this.render.removeAttribute(el, 'class');
        this.render.addClass(el, 'fas');
        this.render.addClass(el, 'fa-heart');
        this.render.addClass(el, 'fav-heart-loan-selected');
        el.setAttribute('data-fav-loan-flag', '1');
        proceedToUpdate = true;
      } else {
        this.displayErrorMessageDialog = true;
      }
    }

    if (proceedToUpdate) {
      this.favoritePropertiesService.updateFavorites(propertyId, el.getAttribute('data-fav-loan-flag'))
        .subscribe((res) => {
          this.favoriteLoansUpdateData = (<any>res).data;
          this.favoritePropertiesService.setFavoritesCount(this.favoriteLoansUpdateData[0].CurrentCount);
          this.favoritePropertiesService.setReloadFavoritePropertiesBar(true);
        }, (error) => {
         console.log('Couldnot update favorites');
      });
    }
  }

/*
  setFavIconClass(IsFavorite: number, el: any): void {
    console.log(IsFavorite);console.log(el.getAttribute('class') === 'far fa-heart');console.log(el.getAttribute('class') === 'fas fa-heart fav-heart-loan-selected');
    if (IsFavorite === 0) {
      if ( el.getAttribute('class') === 'far fa-heart') {
        this.render.removeAttribute(el, 'class');
        this.render.addClass(el, 'fas');
        this.render.addClass(el, 'fa-heart');
        this.render.addClass(el, 'fav-heart-loan-selected');
      }
      if (el.getAttribute('class') === 'fas fa-heart fav-heart-loan-selected') {
        this.render.removeAttribute(el, 'class');
        this.render.addClass(el, 'far');
        this.render.addClass(el, 'fa-heart');
      }
    }
  }
*/

}
